import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, HostListener, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

import { CelumIcon, IconConfiguration } from '@celum/common-components/icon';

@Component({
  selector: 'celum-checkbox-item',
  templateUrl: './checkbox-item.html',
  styleUrls: ['./checkbox-item.less'],
  imports: [CelumIcon, MatCheckbox, TranslatePipe, MatTooltip],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class CheckboxItem {
  @HostBinding('class.checkbox-item') public hostCls = true;

  @HostBinding('attr.data-test-checkbox-item-checked')
  @Input()
  public checked: boolean;
  @Input() public indeterminate: boolean;
  @Input() public additionalText: string;
  @Input() public icon: IconConfiguration;
  @Input() public orientation: 'row' | 'column' = 'row';
  @Input() public checkboxPosition: 'start' | 'end' = 'end'; // only valid for orientation row
  @Input() public text: string;
  @HostBinding('attr.data-test-checkbox-item-disabled')
  @Input()
  public disabled = false;
  @Input() public hoverEnabled = true;
  @Input() public showToolTip = true;

  @Output() public readonly selectionChanged = new EventEmitter<CheckboxItemChange>();

  @HostBinding('class.checkbox-item--orientation-row')
  public get clsRow(): boolean {
    return this.orientation === 'row';
  }

  @HostBinding('class.checkbox-item--orientation-column')
  public get clsColumn(): boolean {
    return this.orientation === 'column';
  }

  @HostBinding('class.checkbox-item--checkboxPosition-start')
  public get clsCheckboxStart(): boolean {
    return this.orientation === 'row' && this.checkboxPosition === 'start';
  }

  @HostBinding('class.checkbox-item--checkboxPosition-end')
  public get clsCheckboxEnd(): boolean {
    return this.orientation === 'row' && this.checkboxPosition === 'end';
  }

  @HostListener('click')
  public onClick(): void {
    if (!this.disabled) {
      const previous = this.checked;
      this.checked = !this.checked;
      this.selectionChanged.emit({
        checked: this.checked,
        preventDefault: () => (this.checked = previous)
      });
    }
  }
}

export interface CheckboxItemChange {
  /**
   * Indicates what the checked state is after the change
   */
  checked: boolean;
  /**
   * Function which can be called to revert the change
   */
  preventDefault: () => void;
}
